// Updated by Vani 30th Sept 25 V1.0.2
import React, { useEffect, useRef } from "react";
import "./style.css";
import LogoImage from "./LogoImage";
import Transformbusiness from "./Transformbusiness";
import Companies from "./Companies";
import Footer from "./Footer";
import { useLocation } from "react-router-dom";
// import ResponsiveComponent from "./ResponsiveComponent";
import Technologies from "./Technologies";
import VideoWithImage from "./VideoWithImage";
function Home() {
  const section3Ref = useRef(null);
  const location = useLocation();
  useEffect(() => {
    if (location.state?.scrollTo === "cards") {
      setTimeout(() => {
        section3Ref.current?.scrollIntoView({ behavior: "auto" });
      }, 10);
    }
  }, [location]);
 
  const scrollToBottom = () => {
    window.scrollTo({
      top: document.documentElement.scrollHeight,
      behavior: "smooth",
    });
  };
 
  return (
    <>
      <div className="home-container">
 
        <VideoWithImage videoSrc={"https://namodeva-images.s3.ap-south-1.amazonaws.com/equinox/videos/ar-vr-mr.mp4"} className="video-container" />
        <video className="home-video" autoPlay muted loop playsInline>
          <source src="https://namodeva-images.s3.ap-south-1.amazonaws.com/equinox/videos/ar-vr-mr.mp4" type="video/mp4" />
        </video>
        <div className="video-bottom-gradient" />
        <div className="side-bar-container">
          <div className="logo-container">
            <LogoImage />
          </div>
          <div onClick={scrollToBottom} className="follow-us-text">
            Follow Us
          </div>
          <div className="gif-container">
            <img src="https://namodeva-images.s3.ap-south-1.amazonaws.com/equinox/mic-loader.gif" alt="loading-gif" className="gif-image" />
          </div>
        </div>
      </div>
 
      <Transformbusiness />
      <Technologies ref={section3Ref} />
      <Companies />
      <Footer />
    </>
  );
}
 
export default Home;
 
// <ResponsiveComponent ref={section3Ref} />;
